var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({class:[_vm.getButtonPositio, _vm.getButtonTypeStyles],attrs:{"color":_vm.color},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.getButtonOptions,false),[_vm._v(" "+_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }